/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

import { StoreMallDirectory, FormatBold, Language } from "@material-ui/icons";

import CustomDropdown from "../CustomDropdown/CustomDropdown.jsx";
import Button from "../CustomButtons/Button.jsx";

import headerLinksStyle from "../../assets/jss/material-kit-react/components/headerLinksStyle.jsx";

function HeaderLinks(props) {
  const { classes, language, match, history } = props;
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Button
          color="transparent"
          target="_blank"
          className={classes.navLink}
          onClick={() =>
            history.push(window.language.currUrl(match, "aboutus"))
          }
        >
          {language.about}
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          color="transparent"
          target="_blank"
          className={classes.navLink}
          onClick={() =>
            history.push(window.language.currUrl(match, "publications"))
          }
        >
          {language.publications}
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          color="transparent"
          target="_blank"
          className={classes.navLink}
          onClick={() =>
            window.location.href = 'https://ccep.buildgreenalbania.org/'
          }
        >
          {language.dgs}
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText="Environmental Digitalization Program"
          buttonProps={{
            className: classes.navLink,
            color: "transparent"
          }}
          //buttonIcon={Language}
          dropdownList={[
            // <Link
            //   to="#"
            //   className={classes.dropdownLink}
            //   onClick={(e) => {
            //     e.preventDefault();
            //     // window.location.href = "https://digitalgreenskills.buildgreenalbania.org/eng/digital-map";
            //     window.open(window.language.currUrl(match, "digital-map"), "_blank");
            //   }}
            // >
            //   Digital Mapping
            // </Link>,
            <Link
              to="#"
              className={classes.dropdownLink}
              onClick={(e) => {
                e.preventDefault();
                // window.location.href = "https://digitalgreenskills.buildgreenalbania.org/eng/digital-map";
                window.open("https://ccep.buildgreenalbania.org/eng/digital-map", "_blank");
              }}
            >
              Regional Mapping
            </Link>,
            <Link
              to="#"
              className={classes.dropdownLink}
              onClick={(e) => {
                e.preventDefault();
                // window.location.href = "https://buildgreenalbania.org/circular_businesses_wb.html";
                window.open("https://buildgreenalbania.org/circular_businesses_wb.html", "_blank");
              }}
            >
              Circular Business
            </Link>,
            <Link
              to="#"
              className={classes.dropdownLink}
              onClick={(e) => {
                e.preventDefault();
                // window.location.href = "http://37.27.212.24:3000/#/map";
                window.open("http://37.27.212.24:3000/#/map", "_blank");
              }}
            >
              Tourism Management Platform
            </Link>,
            <Link
              to="#"
              className={classes.dropdownLink}
              onClick={(e) => {
                e.preventDefault();
                // window.location.href = "https://test.develop.al/webstacionet/index.html";
                window.open("https://igeo-panel.future.al/web/", "_blank");
              }}
            >
              Prespa-Ohrid Water Monitoring Platform
            </Link>
          ]}
        />
      </ListItem>

      {/* <ListItem className={classes.listItem}>
        <Button
          color="transparent"
          target="_blank"
          className={classes.navLink}
          onClick={() =>
            history.push(window.language.currUrl(match, "digital-map"))
          }
        >
          {language.digitalMap}
        </Button>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Button
          color="transparent"
          target="_blank"
          className={classes.navLink}
          onClick={() =>
            window.location.href = 'https://buildgreenalbania.org/circular_businesses_wb.html'
          }
        >
          Circular Bussinesses
        </Button>
      </ListItem> */}
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-facebook"
          title={language.facebook}
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.facebook.com/Build-Green-Group-118078778536093/"
            target="_blank"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-facebook"} />
          </Button>
        </Tooltip>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-twitter"
          title={language.twitter}
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            href="https://twitter.com/bggroup_al"
            target="_blank"
            color="transparent"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-twitter"} />
          </Button>
        </Tooltip>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-tooltip"
          title={language.instagram}
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.instagram.com/buildgreenalbania/"
            target="_blank"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-instagram"} />
          </Button>
        </Tooltip>
      </ListItem>
            <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-tooltip"
          title={language.instagram}
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.linkedin.com/company/build-green-group-albania/"
            target="_blank"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-linkedin"} />
          </Button>
        </Tooltip>
      </ListItem>
      {/* <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText={language.language}
          buttonProps={{
            className: classes.navLink,
            color: "transparent"
          }}
          buttonIcon={Language}
          dropdownList={[
            <Link
              to={window.language.goTo(match, "eng")}
              className={classes.dropdownLink}
            >
              English
            </Link>,
            <Link
              to={window.language.goTo(match, "alb")}
              className={classes.dropdownLink}
            >
              Albanian
            </Link>
          ]}
        />
      </ListItem> */}
    </List>
  );
}

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx